import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { Observable } from 'rxjs';

export const BYPASS_AUTH = new HttpContextToken(() => false);

@Injectable({ providedIn: 'root' })
export class PincodeService {
  constructor(private http: HttpClient) {}

  lookupPincode(pincode: string): Observable<any> {
    return this.http.get(
      `https://api.postalpincode.in/pincode/${pincode}`,
      { context: new HttpContext().set(BYPASS_AUTH, true) }
    );
  }
}
